import { differenceInYears, differenceInDays, parseISO } from 'date-fns'
import settings from './settings'
import i18n from './translate'

const today = new Date()
today.setHours(0, 0, 0)

export function localeDate (value, options) {
  options = options || {
    month: 'long',
    day: 'numeric'
  }
  
  const date = parseISO(value)
  
  if (differenceInYears(date, today)) {
    options.year = 'numeric'
  }
  
  if (!differenceInDays(date, today)) {
    return i18n.gettext('today')
  } else if (differenceInDays(date, today) === -1) {
    return i18n.gettext('yesterday')
  }
  
  return date.toLocaleDateString(settings.LOCALE, options)
}
